import React from "react";

const Wheel = ({ width, yPos, isLeft = false, isTop = false, index, panelCount }) => {
  const offsetStep = 0.06; // Her tekerin bir öncekinden ne kadar geri olacağı
  let indexOffset = 0;
  if(isLeft){
    indexOffset = (panelCount-index) * offsetStep;
  } else {
    indexOffset = index * offsetStep
  }
  const baseX = isLeft ? width / 2 : -width / 2;
  const xPosition = baseX + (isLeft ? -indexOffset : +indexOffset);

  return (
    <group position={[0, yPos, 0]} rotation={isTop ? [Math.PI, 0, 0] : [0, 0, 0]}>
      {/* Alt siyah teker */}
      <mesh position={[xPosition, 0, 0]}>
        <cylinderGeometry args={[0.018, 0.018, 0.01, 32]} />
        <meshStandardMaterial color="black" />
      </mesh>
     
      {/* Üst siyah teker */}
      <mesh position={[xPosition, 0.02, 0]}>
        <cylinderGeometry args={[0.018, 0.018, 0.01, 32]} />
        <meshStandardMaterial color="black" />
      </mesh>

      {/* Bağlantı silindiri */}
      <mesh position={[xPosition, 0.02, 0]}>
        <cylinderGeometry args={[0.006, 0.006, 0.03, 16]} />
        <meshStandardMaterial color="#aaa" />
      </mesh>

      {/* Üst metal parça */}
      <mesh position={[xPosition, 0.04, 0]}>
        <boxGeometry args={[0.03, 0.01, 0.015]} />
        <meshStandardMaterial color="#ccc" />
      </mesh>
    </group>
  );
};

export default Wheel;
